export const calculateHintCost = _ref => {
  let {
    numberOfHintsAvailable,
    numberOfHintsTaken,
    totalHintCostXp
  } = _ref;
  const quotient = Math.floor(totalHintCostXp / numberOfHintsAvailable);
  const remainder = totalHintCostXp % numberOfHintsAvailable;
  const pieces = [];
  for (let i = 0; i < numberOfHintsAvailable; i += 1) {
    pieces[i] = i < remainder ? quotient + 1 : quotient;
  }
  return pieces[numberOfHintsTaken];
};